import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import styled from 'styled-components'
import { Button } from "@flourish-white-label/ui";
import { Box } from 'rebass'
import BackgroundImage from 'gatsby-background-image'
import { navigate } from 'gatsby';
import AnalyticsFactory from "../analytics/analytics";
import { USER_CLICK_ON_REGISTER } from '../analytics/events';

const BackgroundSection = ({ className }) => {
  const data = useStaticQuery(
    graphql`
      query {
        desktop: file(relativePath: { eq: "woman.png" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )

  const imageData = data.desktop.childImageSharp.fluid

  const registerAction = () => {
    AnalyticsFactory.getInstance().logEvent({ name: USER_CLICK_ON_REGISTER });
    navigate('/app/onboarding')
  }

  return (
    <BackgroundImage
      Tag="section"
      className={className}
      fluid={imageData}
    >
      <Box height={'60vh'}
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
      }}>
        <Box mb={4}>
          <Button children={'Criar Conta'}  size="medium" appearance="primary" onClick={() => registerAction()}/>
        </Box>
      </Box>
    </BackgroundImage>
  )
}

const RegisterSection = styled(BackgroundSection)`
  width: 100%;
  background-position: top center;
  background-repeat: repeat-y;
  background-size: cover;
`

export default RegisterSection
